export const footerWatcher = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            actions: ['hideFooter'],
            cond: 'shouldHideFooter',
          },
          {
            actions: ['showFooter'],
          },
        ],
      },
    },
  },
};
